var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"bg-title text-left d-center-start mt-5 border"},[_c('i',{staticClass:"iconfont text-warning h1 mr-3",class:_vm.subIcon}),_c('p',{staticClass:"font-weight-bold"},[_vm._v(_vm._s(_vm.subTitle))])])
}
var staticRenderFns = []

export { render, staticRenderFns }